<template>
  <a-select
    allowClear
    :placeholder="$t(`form.Currency`)"
    style="width: 100%"
    v-model="currency"
    :disabled="disabled"
    @change="change"
  >
    <a-select-option v-for="item in currencyList" :key="item.code" :value="item.code">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'SelectCurrency',
  props: {
    value: {},
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      currency: '',
      currencyList: [
        {
          name: this.$t('人民币'),
          code: 'CNY',
        },
        {
          name: this.$t('美元'),
          code: 'USD',
        },
        {
          name: this.$t('泰铢'),
          code: 'THB',
        },
      ],
    }
  },
  methods: {
    change(data) {
      this.$emit('update:value', data)
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.currency = val
      },
    },
  },
}
</script>
